'use client';

import { useEffect } from 'react';

import { ClientErrorReportLevel } from '@/enums/ClientErrorReportLevel';
import { recoverChunkLoadFailure } from '@/features/runtime/chunkRecovery';
import { reportClientError } from '@/lib/observability/clientRollbar';

const GlobalError = ({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) => {
    useEffect(() => {
        const didRecover = recoverChunkLoadFailure({
            error,
            buildMarker: process.env.NEXT_PUBLIC_CHATTENGER_BUILD_MARKER,
            browserWindow: typeof window === 'undefined' ? null : window,
        });

        if (didRecover) {
            return;
        }

        reportClientError({
            error,
            extra: {
                digest: error.digest || null,
                boundary: 'global-error.tsx',
            },
            level: ClientErrorReportLevel.CRITICAL,
        });
    }, [error]);

    const handleRetry = () => {
        reset();
    };

    return (
        <html lang="en">
            <body
                style={{
                    minHeight: '100vh',
                    margin: 0,
                    display: 'grid',
                    placeItems: 'center',
                    padding: '32px',
                    textAlign: 'center',
                    background: 'linear-gradient(180deg, #080b10 0%, #131922 100%)',
                    color: '#f5f7fb',
                }}
                data-testid="global-error-root"
            >
                <div style={{ display: 'grid', gap: '16px', maxWidth: '440px' }} data-testid="global-error-div">
                    <h1 style={{ margin: 0, fontSize: '2rem' }} data-testid="global-error-title">
                        A critical error occurred
                    </h1>
                    <p style={{ margin: 0, opacity: 0.78 }} data-testid="global-error-description">
                        The failure was reported. Retry the app shell.
                    </p>
                    <button
                        onClick={handleRetry}
                        style={{
                            appearance: 'none',
                            border: '1px solid rgba(226, 232, 240, 0.14)',
                            borderRadius: '999px',
                            padding: '12px 18px',
                            background: 'rgba(229, 236, 245, 0.12)',
                            color: 'inherit',
                            cursor: 'pointer',
                        }}
                        type="button"
                        data-testid="global-error-button"
                    >
                        Retry
                    </button>
                </div>
            </body>
        </html>
    );
};

export default GlobalError;
